import React from 'react'
import Hero from './Hero/Hero'
import Services from './Services/Services'
import AboutUs from './AboutUs/AboutUs'
import OurServices from './OurServices/OurServices'
import Advantages from './Advantages/Advantages'
import Feedback from './Feedback/Feedback'
import { useAppSelector } from '../../store/hooks'
import Loader from '../../components/Loader/Loader'
import { Helmet } from 'react-helmet-async'

const Home = () => {
    const { loading } = useAppSelector(state => state.info)

    return (
        <>
       <Helmet>
            <title>
                Автоматизация технологических процессов и производств | Phoenix Programs
            </title>

            <meta
                name="description"
                content="Phoenix Programs предоставляет передовые решения в области автоматизации технологических процессов, разработки ПО для ПЛК и SCADA, веб-разработки и инженерных систем."
            />

            <link rel="canonical" href="https://phoenix-programs.ru/" />

            {/* Open Graph */}
            <meta property="og:type" content="website" />
            <meta property="og:locale" content="ru_RU" />
            <meta property="og:url" content="https://phoenix-programs.ru/" />
            <meta
                property="og:title"
                content="Автоматизация технологических процессов и производств | Phoenix Programs"
            />
            <meta
                property="og:description"
                content="Комплексные решения по автоматизации, программированию ПЛК, разработке SCADA-систем и промышленной интеграции."
            />
            <meta
                property="og:image"
                content="https://phoenix-programs.ru/logo192.png"
            />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta
                name="twitter:title"
                content="Автоматизация технологических процессов | Phoenix Programs"
            />
            <meta
                name="twitter:description"
                content="Решения по автоматизации, SCADA, ПЛК и промышленной инженерии."
            />
            <meta
                name="twitter:image"
                content="https://phoenix-programs.ru/logo192.png"
            />

            <meta name="robots" content="index, follow" />
        </Helmet>

            {loading && <Loader />}
            <Hero />
            <Services />
            <AboutUs />
            <OurServices />
            <Advantages />
            <Feedback />
        </>
    )
}

export default Home